import { createAsyncThunk } from "@reduxjs/toolkit";
import { GBP_INCOME_FUND_DEAL_ID } from "gatsby-env-variables";
import { clientInvestSdk } from "@utils/clientInvestSdk";
import { logException } from "@helpers/logException/logException";
import type { FundRestructureChoiceState } from "./fundRestructure.reducer";

export const fetchFundRestructureChoicesThunk = createAsyncThunk<
  FundRestructureChoiceState["choices"],
  void
>("FUND_RESTRUCTURE:FETCH_CHOICES", async (_, { rejectWithValue }) => {
  try {
    const response = await clientInvestSdk.getNoticePeriodChoices(
      GBP_INCOME_FUND_DEAL_ID
    );
    return response.data.map((choice) => ({
      sourceCommitmentId: choice.sourceCommitmentId,
      submission: choice.submission,
      reallocationIds: choice.reallocationIds,
      isProcessed: choice.isProcessed ?? false,
    }));
  } catch (e: unknown) {
    logException({
      message: "Error fetching fund restructure choices",
      exception: e,
    });
    return rejectWithValue(e instanceof Error ? e.message : "Unknown error");
  }
});

export const fetchFundRestructureSourceDealThunk = createAsyncThunk<
  Record<string, unknown> | null,
  void
>("FUND_RESTRUCTURE:FETCH_SOURCE_DEAL", async (_, { rejectWithValue }) => {
  try {
    const response = await clientInvestSdk.getDeal(GBP_INCOME_FUND_DEAL_ID);
    return (response.data?.metadata as Record<string, unknown> | null) ?? null;
  } catch (e: unknown) {
    logException({
      message: "Error fetching fund restructure source deal",
      exception: e,
    });
    return rejectWithValue(e instanceof Error ? e.message : "Unknown error");
  }
});
